// extracted by mini-css-extract-plugin
module.exports =  {"link":"XnDJ3uFnRZ_IQmAKEd46"};